/**
 * Phase 17 — Ausgaben lesen: entity_expenses + merged Blob.
 */

import { listAggregateExpenses } from '../infrastructure/storage/domainAggregateStore';
import { listEntityExpenses } from '../infrastructure/storage/entityAggregateStore';
import { readBlobFirstWithAggregateFallback } from './canonicalEntityRead';
import { readSyncWithBlobPriority, readArrayFieldFromMergedBlob } from './businessStateSync';

/** @type {Map<string, object[]>} */
const expensesReadCache = new Map();

export function readExpensesFromMergedBlob(businessId) {
  return readArrayFieldFromMergedBlob(businessId, 'expenses', getCachedExpensesRead);
}

export async function readExpensesFromBestSource(businessId) {
  return readBlobFirstWithAggregateFallback(
    businessId,
    readExpensesFromMergedBlob,
    listAggregateExpenses,
    listEntityExpenses,
    ['id', 'expenseId']
  );
}

export async function refreshExpensesReadCache(businessId, preloaded) {
  const expenses =
    preloaded !== undefined
      ? Array.isArray(preloaded)
        ? preloaded
        : []
      : await readExpensesFromBestSource(businessId);
  if (businessId) {
    expensesReadCache.set(String(businessId), expenses);
  }
  return expenses;
}

export function getCachedExpensesRead(businessId) {
  if (!businessId) return null;
  return expensesReadCache.get(String(businessId)) ?? null;
}

/** Sofort nach UI-Speichern — Écart beim Logout sieht neue Dépenses ohne Reload. */
export function setCachedExpensesRead(businessId, expenses) {
  if (!businessId) return;
  expensesReadCache.set(String(businessId), Array.isArray(expenses) ? expenses : []);
}

export function clearExpensesReadCache(businessId) {
  if (businessId) {
    expensesReadCache.delete(String(businessId));
  } else {
    expensesReadCache.clear();
  }
}

export function readExpensesSyncForBusiness(businessId) {
  return readSyncWithBlobPriority(
    businessId,
    readExpensesFromMergedBlob,
    getCachedExpensesRead,
    'id',
    'expenseId'
  );
}
